<template>
<div class=" " :class="{'swiperObj':$store.state.innerWidth>=815}">
    <div class="swiperContent" ref="content">
        <swiper :options="swiperOption" v-if="showSwiper" :class="{'padding-30':showBtn}" class="swiperCarrousel SwiperArticles">
            <swiper-slide class="swiper-slide box-slide" :class="{'swiper-no-swiping':!canSwiper}" v-if="index<5" v-for="(course,index) in courseList">
                <div class="couses-item minHeight pointer" :class="courseList.length == index+1?'':'mgRight-10'" @click="goCourseDetail(course)">
                    <div class="flex-span">
                        <span class="timeTip timeTipJia SemiBold nowrap"  
                        v-if="$store.getters.getTrim(mode)=='FT'||$store.getters.getTrim(mode)=='PT'||$store.getters.getTrim(mode)=='DL'||$store.getters.getTrim(mode)=='EL'"
                        v-for="mode in course.learningMode">
                        {{$t('message.'+$store.getters.getTrim(mode)+'')}}
                        </span>
                    </div>
                    <div>
                        <a href="javascript:;" style="color: inherit">
                            <h4 class="SemiBold courseTitle fourline-box wrap">{{$store.getters.getObject(course.langMap).title}}</h4>
                        </a>
                        <div class="twoline-box wrap">
                            <p >{{$store.getters.getObject(course.langMap).grantingBody[0]}}</p>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" v-if="showBtn" slot="button-prev">
            <i class="icon-arrow-down"></i>
        </div>
        <div class="swiper-button-next" v-if="showBtn" slot="button-next">
            <i class="icon-arrow-down"></i>
        </div>
    </div>
</div>
</template>
<script>

import Swiper from 'swiper';
export default {
    data() {
        return {
            totalRows: 0,
            showBtn:true,
            canSwiper:true,
            showSwiper:false,
            swiperOption: {
                slidesPerView: 2.2,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
        }
    },
    computed:{
        innerwidth(){
          return this.$store.state.innerWidth;
        }
    },
    watch:{
        innerwidth (news,old) {
            this.showSwiper = false;
            this.setWidth()
        },
        courseList: function(n, o) {
            this.setWidth()
        },
     },
    props: {
        callback:null,
        courseList:null,
    },
    methods: {
        goCourseDetail: function(course) {
            let key = ""
            // if (course.dataSource == 'edx') {
                key = encodeURIComponent(course.key)
            // } else {
            //     key = course.id
            // }
            this.$router.push({ path: '/coursesDetail/' + course.dataSource + "/" + key, query:{lang:this.$store.state.language,name:this.$store.getters.replaceEvent(this.$store.getters.getObject(course.langMap).title)} });
            window.scrollTo(0, 0);
        },
        setWidth:function(){
            var that = this;
            this.$refs.content.style.width= '100%'
            if(this.$store.state.innerWidth>=1345){
                this.showBtn = false;
                this.canSwiper = false;
                // this.$refs.content.style.width= '100%'
            }else if(this.$store.state.innerWidth >= 1080){
                this.showBtn = true;
                this.canSwiper = false;
                // this.$refs.content.style.width= 1118 + 'px'
            }else if(this.$store.state.innerWidth >= 815){
                this.showBtn = true;
                this.canSwiper = false;
                // this.$refs.content.style.width= 855 + 'px'
            }else{
                this.showBtn = false;
                this.canSwiper = true;
                this.$refs.content.style.width= '100%'
            }
            // console.log(this.$store.state.innerWidth)
            if(this.$store.state.innerWidth>=1345){
                this.swiperOption = {
                    slidesPerView: 5,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(this.$store.state.innerWidth >= 1080){
                var space = (this.$store.state.innerWidth - 85 -(250)*4)/3;
                this.swiperOption = {
                    slidesPerView: 4,
                    spaceBetween: space,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(this.$store.state.innerWidth >= 815){
                var space = (this.$store.state.innerWidth - 85 -(250)*3)/2;
                this.swiperOption = {
                    slidesPerView: 3,
                    spaceBetween: space,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(this.$store.state.innerWidth>768){
                this.swiperOption = {
                    slidesPerView: 3,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(this.$store.state.innerWidth>650){
                this.swiperOption = {
                    slidesPerView: 2.9,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(this.$store.state.innerWidth>550){
                this.swiperOption = {
                    slidesPerView: 2.5,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else{
                this.swiperOption = {
                    slidesPerView: 2.2,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
            
                this.showSwiper = false;
                this.$nextTick(() => {
                    this.showSwiper = true
                });
        }
    },
    mounted() {
        // this.mySwiper = new Swiper('.swiper-container')
        this.setWidth();
        var that = this;
        setTimeout(function(){
            that.setWidth();
        },500)
    }
}
</script>